/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetBulkClassesRequest
 */
export interface GetBulkClassesRequest {
    /**
     * 
     * @type {Array<ApiUserTasksGetPageParameter>}
     * @memberof GetBulkClassesRequest
     */
    classIds: Array<ApiUserTasksGetPageParameter> | null;
}

/**
 * Check if a given object implements the GetBulkClassesRequest interface.
 */
export function instanceOfGetBulkClassesRequest(value: object): value is GetBulkClassesRequest {
    if (!('classIds' in value) || value['classIds'] === undefined) return false;
    return true;
}

export function GetBulkClassesRequestFromJSON(json: any): GetBulkClassesRequest {
    return GetBulkClassesRequestFromJSONTyped(json, false);
}

export function GetBulkClassesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBulkClassesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'classIds': (json['classIds'] == null ? null : (json['classIds'] as Array<any>).map(ApiUserTasksGetPageParameterFromJSON)),
    };
}

export function GetBulkClassesRequestToJSON(json: any): GetBulkClassesRequest {
    return GetBulkClassesRequestToJSONTyped(json, false);
}

export function GetBulkClassesRequestToJSONTyped(value?: GetBulkClassesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classIds': (value['classIds'] == null ? null : (value['classIds'] as Array<any>).map(ApiUserTasksGetPageParameterToJSON)),
    };
}

